import { useState } from 'react';
import { Box, IconButton, Popover, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// A small "i in a circle" button that opens a popup with more context for a
// field or setting. Pass either a `title`/`description` pair directly, or an
// `info` object (e.g. from a lookup lib) shaped as { title, description }.
const InfoButton = ({ title, description, info, size = 'small' }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const resolvedTitle = title ?? info?.title;
  const resolvedDescription = description ?? info?.description;

  if (!resolvedTitle && !resolvedDescription) {
    return null;
  }

  const handleOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        size={size}
        onClick={handleOpen}
        aria-label={resolvedTitle ? `More information about ${resolvedTitle}` : 'More information'}
        sx={{ p: 0.25, color: 'text.secondary' }}>
        <InfoOutlinedIcon sx={{ fontSize: 18 }} />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
        <Box sx={{ p: 2, maxWidth: 320 }}>
          {resolvedTitle ? (
            <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>
              {resolvedTitle}
            </Typography>
          ) : null}
          {resolvedDescription ? (
            <Typography variant="body2" color="text.secondary">
              {resolvedDescription}
            </Typography>
          ) : null}
        </Box>
      </Popover>
    </>
  );
};

export default InfoButton;
